import api from './../api';
import request from "../utils/requestToJavaServer";
export function Diagnosis_Static(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.diagnosisApi.DIAGNOSIS_STATIC,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_Dynamic(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.diagnosisApi.DIAGNOSIS_DYNAMIC,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_Dynamic_status({taskId}:any){
    return new Promise((resolve,reject)=>{
        request.get(api.diagnosisApi.DIAGNOSIS_DYNAMIC_STATUS,{
            params:{taskId}
        }).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_History({category,pageNum,pageSize}:any){
    return new Promise((resolve,reject)=>{
        request.get(api.diagnosisApi.DIAGNOSIS_HISTORY,{
            params:{category,pageNum,pageSize}
        }).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_Dynamic_Result({rawDataId}:any){
    return new Promise((resolve,reject)=>{
        request.get(api.diagnosisApi.DIAGNOSIS_DYNAMIC_RESULT,{
            params:{rawDataId}
        }).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_Static_Result({rawDataId}:any){
    return new Promise((resolve,reject)=>{
        request.get(api.diagnosisApi.DIAGNOSIS_STATIC_RESULT,{
            params:{rawDataId}
        }).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Diagnosis_Report(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.diagnosisApi.DIAGNOSIS_REPORT,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}